"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2.50049",
    y: "2.50049",
    width: "19",
    height: "19",
    rx: "9.5",
    fill: fill,
    stroke: "white"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6161 8.68728C16.8606 8.93178 16.8606 9.3282 16.6161 9.5727L10.877 15.3118C10.6325 15.5563 10.236 15.5563 9.99153 15.3118L7.38284 12.7031C7.13834 12.4586 7.13834 12.0622 7.38284 11.8177C7.62734 11.5732 8.02376 11.5732 8.26826 11.8177L10.4342 13.9837L15.7307 8.68728C15.9752 8.44278 16.3716 8.44278 16.6161 8.68728Z",
    fill: "white"
  }));
};

exports["default"] = _default;